import {useEffect, useState} from "react";
import associateServices from "../../../../../services";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import SvgIcon from "../../../../../components/svg-icon";
import Loading from "../../../../../components/loading";
import MathHelper from "../../../../../helpers/math-helper";

const TryProvidersModal = (props) => {
    const {show, setShow, providers, handleMethod, isWithdraw = false} = props

    const [loading, setLoading] = useState(true)
    const {t} = useTranslation()

    useEffect(() => {

        if (show) {
            setLoading(true)
            const bdy = document.body
            bdy.classList?.add('modal-open')

            const mdl = document.getElementById('deposit-modal')
            mdl.classList?.add('show')

            mdl.style.display = 'block'
            mdl.style.backgroundColor = 'rgba(0,0,0,.7)'

            mdl.classList?.add('modal-fade')

            setTimeout(() => setLoading(false), 1000)
            return () => {
                bdy.classList?.remove('modal-open')
                mdl.classList?.remove('show')
            }
        } else {
            setLoading(false)

            const bdy = document.body
            bdy.classList?.add('modal-open')

            const mdl = document.getElementById('deposit-modal')
            mdl.classList?.remove('show')

            mdl.style.display = 'none'
            mdl.style.backgroundColor = 'rgba(0,0,0,.7)'


            bdy.classList?.remove('modal-open')
            mdl.classList?.remove('show')

        }
    }, [show])

    return (
        <div
            className="modal modal--big fade"
            id="deposit-modal"
            tabIndex={-1}
            aria-labelledby="deposit-modal"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal__content">
                        <div className="modal__head">
                            <h6 className="modal__title">{t('general.select-payment-method', 'Payment Method')}</h6>
                            <button
                                className="modal__close"
                                type="button"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={e => setShow(false)}
                            >
                                <SvgIcon id={'x'}/>
                            </button>
                        </div>
                        <div className="modal__scrollable">

                            {
                                loading ? <Loading/> :

                                    <div className="modal__deposit-grid">
                                        {
                                            providers?.map(method => {
                                                return (
                                                    <a onClick={e => {
                                                        handleMethod(method)
                                                    }} className="deposit"
                                                       key={method?.id}>
                                                        <div className="deposit__img">
                                                            <img src={method?.logo || method?.method?.logo_light} alt=""
                                                                 className={`method-img ${method?.name}`}/>
                                                        </div>
                                                        <span className="deposit__title text-secondary small">
                                                    {`${MathHelper.formatAsset(isWithdraw ? method?.min_withdraw : method?.min_deposit)} - ${MathHelper.formatAsset(isWithdraw ? method?.max_withdraw : method?.max_deposit)} TL`}
                                                </span>
                                                    </a>

                                                )
                                            })
                                        }
                                    </div>
                            }


                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}

export default TryProvidersModal
